import { Injectable } from '@angular/core';
import { ApiClientService } from '../../core/services/api-client.service';
import { EvaluationConfig, Language } from './evaluation.model';

@Injectable({
  providedIn: 'root',
})
export class EvaluationService extends ApiClientService {
  /**
   * Retrieves the evaluation configuration for a given language
   * GET /config/evaluation/:lang
   */
  getEvaluationConfig(lang: Language) {
    return this.get<EvaluationConfig>(`/config/evaluation/${lang}`);
  }

  /**
   * Updates the evaluation configuration
   * PUT /config/evaluation
   */
  updateEvaluationConfig(config: EvaluationConfig[]) {
    return this.put<EvaluationConfig[]>('/config/evaluation', config);
  }

  /**
   * Deletes a motive from the evaluation configuration
   * DELETE /config/evaluation/:lang/motive/:motiveId
   */
  deleteMotive(lang: Language, motiveId: string) {
    return this.delete(`/config/evaluation/${lang}/motive/${motiveId}`);
  }

  /**
   * Updates a single evaluation configuration for a specific language
   * PUT /config/evaluation
   */
  updateSingleConfig(config: EvaluationConfig) {
    return this.put<EvaluationConfig[]>('/config/evaluation', [config]);
  }
}
